import { storage } from '../../config/firebaseConfig';
//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 1 => HANDLE MARKER STATE
/// 
export const openNewMarkerModal = () => {
    return {
        type: "OPEN_NEW_MARKER_MODAL",
    }
}

export const openBriefMarkerModal = () => {
    return {
        type: "OPEN_BRIEF_MARKER_MODAL",
    }
}

export const openEditMarkerModal = () => {
    return {
        type: "OPEN_EDIT_MARKER_MODAL",
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 2 => ADD MARKER
/// 
export const addNewDefect = (proid, floorid, coordinates, selectedTagIds, selectedSnagPictures, title, description, deadline, isDeadlineComplete, isFirstOrder) => {
    return async (dispatch, getState, { getFirestore, getFirebase }) => {
        /// dispatch to indicate ongoing process
        console.log("new marker process start")
        dispatch({ type: "MARKER_ADDING" });

        // async call to upload new shape
        const firebase = getFirebase();
        const firestore = getFirestore();

        // generate new marker id
        var newMarkerid = floorid + firestore.collection(`Projects/${proid}/Markers`).doc().id;
        const markerRef = firestore.collection('Projects').doc(proid).collection('Markers').doc(newMarkerid);

        // upload files in loop and add non null files to list (to be added to project document)
        var uploadedFilesUrl = [];
        if (selectedSnagPictures.length > 0) {
            for (var i = 0; i < selectedSnagPictures.length; ++i) {
                var result = await addMarkerImageFile(proid, newMarkerid, selectedSnagPictures[i]);
                if (result != null) {
                    console.log(`Available at: ${result.substring(0, 5)}`);
                    uploadedFilesUrl = [...uploadedFilesUrl, result];
                }

            }
            /// dispatch to indicate successful file uploaded
            dispatch({ type: "MARKER_FILES_ADDED" });
        }

        // write data on firestore
        await markerRef.set({
            /// META
            floorid: floorid,
            markerid: newMarkerid,
            proid: proid,
            isFirstOrder: isFirstOrder,

            /// GENERAL
            title: title ?? "",
            description: description ?? "",
            dateCreated:  Date.now(),
            deadline: deadline,
            isDeadlineComplete: isDeadlineComplete,

            /// SPECIFIC
            coordinates: coordinates,
            identifier: "0",
            tags: selectedTagIds ?? [],
            snagPictures: [...uploadedFilesUrl].length <= 0 ? [] : firestore.FieldValue.arrayUnion(...uploadedFilesUrl),
        });

        /// dispatch to success process
        dispatch({ type: "MARKER_ADDED" });
    };
}

export const addNewElevation = (proid, floorid, coordinates, selectedElevationFiles, title, description, isFirstOrder) => {
    return async (dispatch, getState, { getFirestore, getFirebase }) => {
        /// dispatch to indicate ongoing process
        dispatch({ type: "MARKER_ADDING" });

        // async call to upload new shape
        const firebase = getFirebase();
        const firestore = getFirestore();

        // generate new marker id
        var newMarkerid = floorid + firestore.collection(`Projects/${proid}/Markers`).doc().id;
        var batch = firestore.batch();
        const markerRef = firestore.collection('Projects').doc(proid).collection('Markers').doc(newMarkerid);

        // write new data on firestore
        await markerRef.set({
            /// META
            floorid: floorid,
            markerid: newMarkerid,
            proid: proid,
            isFirstOrder: isFirstOrder,

            /// GENERAL
            title: title ?? "",
            description: description ?? "",
            dateCreated: Date.now(),

            /// SPECIFIC
            coordinates: coordinates,
            identifier: "1",
            tags: ["elevation"],

            /// FILES
            floorsMap: {},
            files: [],
            imageFilesList: [],
            imageFilesCount: 0,
            filesMap: {},
        });

        // upload files in loop and add non null files to list (to be added to project document)
        var uploadedFilesUrl = [];
        var uploadedFilesName = [];
        if (selectedElevationFiles.length > 0) {
            for (var i = 0; i < selectedElevationFiles.length; ++i) {
                var result = await addMarkerElevationFile(proid, newMarkerid, selectedElevationFiles[i]);
                if (result != null) {
                    console.log(`Available at: ${result.substring(0, 5)}`);
                    var uploadedFileName = await selectedElevationFiles[i].name.replaceAll(/[/\-.()\s]/g, '').toLowerCase();
                    var uploadedFileNameWithoutExt = uploadedFileName.substring(0, uploadedFileName.length - 'pdf'.length);
                    uploadedFilesUrl = [...uploadedFilesUrl, result];
                    uploadedFilesName = [...uploadedFilesName, uploadedFileNameWithoutExt];

                    // batch update the floorsMap in firestore
                    var newFloorid = newMarkerid + uploadedFileNameWithoutExt;
                    batch.update(markerRef, {
                        [`floorsMap.${newFloorid}`]: {
                            dateCreated: firestore.FieldValue.serverTimestamp(),
                            fileName: uploadedFileNameWithoutExt,
                            floorid: `${newFloorid}`,
                            name: uploadedFileNameWithoutExt,
                            parentid: floorid,
                            proid: proid,
                        }
                    });
                }
            }
            /// dispatch to indicate successful file uploaded
            dispatch({ type: "MARKER_FILES_ADDED" });
        }

        // update data on firestore with files and floorsMap
        batch.update(markerRef, {
            /// FILES
            files: [...uploadedFilesUrl].length <= 0 ? [] : firestore.FieldValue.arrayUnion(...uploadedFilesUrl),
            imageFilesList: [...uploadedFilesName].length <= 0 ? [] : firestore.FieldValue.arrayUnion(...uploadedFilesName),
            imageFilesCount: firestore.FieldValue.increment(uploadedFilesName.length),
        });

        await batch.commit();

        /// dispatch to success process
        dispatch({ type: "MARKER_ADDED" });
    };
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 3 => UPDATE MARKER
/// 
export const updateDefect = (markerid, proid, floorid, coordinates, tags, newSnagPictures, title, description, deadline, isDeadlineComplete) => {
    return async (dispatch, getState, { getFirestore }) => {
        /// dispatch to indicate ongoing process
        dispatch({ type: "MARKER_UPDATING" });

        // async call to upload new shape
        const firestore = getFirestore();

        var batch = firestore.batch();
        const markerRef = firestore.collection('Projects').doc(proid).collection('Markers').doc(markerid);

        // upload files in loop and add non null files to list (to be added to project document)
        var uploadedFilesUrl = [];
        if (newSnagPictures.length > 0) {
            for (var i = 0; i < newSnagPictures.length; ++i) {
                var result = await addMarkerImageFile(proid, markerid, newSnagPictures[i]);
                if (result != null) {
                    console.log(`Available at: ${result.substring(0, 5)}`);
                    uploadedFilesUrl = [...uploadedFilesUrl, result];
                }

            }
            /// dispatch to indicate successful file uploaded
            dispatch({ type: "MARKER_FILES_UPDATED" });
        }

        // batch update data on firestore
        batch.update(markerRef, {
            /// GENERAL
            title: title ?? "",
            description: description ?? "",
            deadline: deadline,
            isDeadlineComplete: isDeadlineComplete,

            /// SPECIFIC
            coordinates: coordinates,
            tags: tags,
        });

        // batch update snagPictures on firestore
        if (uploadedFilesUrl.length > 0) {
            batch.update(markerRef, {
                snagPictures: firestore.FieldValue.arrayUnion(...uploadedFilesUrl),
            });
        }

        await batch.commit()

        /// dispatch to success process
        dispatch({ type: "MARKER_UPDATED" });
    }
}

/// TODO: BETTER SOLUTION FOR APPENDING NEW PARTS TO EXISTING MAP IS NEEDED
//          right now we are merging client side, we need to find something like map union
export const updateElevation = (markerid, proid, floorid, floorsMap, coordinates, newFiles, title, description) => {
    return async (dispatch, getState, { getFirestore }) => {
        /// dispatch to indicate ongoing process
        dispatch({ type: "MARKER_UPDATING" });

        // async call to upload new shape
        const firestore = getFirestore();

        var batch = firestore.batch();
        const markerRef = firestore.collection('Projects').doc(proid).collection('Markers').doc(markerid);

        // upload files in loop and add non null files to list (to be added to project document)
        var uploadedFilesUrl = [];
        var uploadedFilesName = [];
        if (newFiles.length > 0) {
            for (var i = 0; i < newFiles.length; ++i) {
                var result = await addMarkerElevationFile(proid, markerid, newFiles[i]);
                if (result != null) {
                    console.log(`Available at: ${result.substring(0, 5)}`);
                    var uploadedFileName = await newFiles[i].name.replaceAll(/[/\-.()\s]/g, '').toLowerCase();
                    var uploadedFileNameWithoutExt = uploadedFileName.substring(0, uploadedFileName.length - 'pdf'.length);
                    uploadedFilesUrl = [...uploadedFilesUrl, result];
                    uploadedFilesName = [...uploadedFilesName, uploadedFileNameWithoutExt];

                    // batch update the partsMap in firestore
                    var newFloorid = markerid + uploadedFileNameWithoutExt;
                    batch.update(markerRef, {
                        [`floorsMap.${newFloorid}`]: {
                            dateCreated: firestore.FieldValue.serverTimestamp(),
                            fileName: uploadedFileNameWithoutExt,
                            floorid: `${newFloorid}`,
                            name: uploadedFileNameWithoutExt,
                            parentid: floorid,
                            proid: proid,
                        }
                    });
                }

            }
            /// dispatch to indicate successful file uploaded
            dispatch({ type: "MARKER_FILES_ADDED" });
        }

        // batch update data on firestore
        batch.update(markerRef, {
            /// GENERAL
            title: title ?? "",
            description: description ?? "",

            /// SPECIFIC
            coordinates: coordinates,
            tags: ["elevation"],
        });

        // batch update files data on firestore
        if (uploadedFilesUrl.length > 0) {
            batch.update(markerRef, {
                /// FILES
                files: firestore.FieldValue.arrayUnion(...uploadedFilesUrl),
                imageFilesList: firestore.FieldValue.arrayUnion(...uploadedFilesName),
                imageFilesCount: firestore.FieldValue.increment(uploadedFilesName.length),
            });
        }

        await batch.commit()

        /// dispatch to success process
        dispatch({ type: "MARKER_UPDATED" });
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 4 => COMMENT ON MARKERS
/// 
export const addAComment = (userData, proid, newMarkerid, comment, imageFiles) => {
    return async (dispatch, getState, { getFirebase, getFirestore }) => {
        /// dispatch to indicate ongoing process
        dispatch({ type: "COMMENT_ADDING" });

        // async call to upload new shape
        const firebase = getFirebase();
        const firestore = getFirestore();
        // upload now
        var newCid = firestore.collection(`Projects/${proid}/Markers/${newMarkerid}/Comments`).doc().id;

        // upload files in loop and add non null files to list (to be added to project document)
        var uploadedFilesUrl = [];
        if (imageFiles.length > 0) {
            for (var i = 0; i < imageFiles.length; ++i) {
                var result = await addCommentImageFile(proid, imageFiles[i]);
                if (result != null) {
                    console.log(`Available at: ${result.substring(0, 5)}`);
                    uploadedFilesUrl = [...uploadedFilesUrl, result];
                }

            }
            /// dispatch to indicate successful file uploaded
            dispatch({ type: "COMMENT_FILES_ADDED" });
        }

        await firebase.database().ref().child(`Projects/${proid}/Markers/${newMarkerid}/Comments/${newCid}`).set({
            cid: newCid,
            uid: userData.uid,
            proid: proid,
            markerid: newMarkerid,
            comment: comment,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
            profilePic: userData.profilePic,
            name: userData.name,
            imageFiles: uploadedFilesUrl,

        });

        /// dispatch to success process
        dispatch({ type: "COMMENT_ADDED" });
    };
}

export const deleteAComment = (proid, markerid, cid) => {
    return async (dispatch, getState, { getFirebase }) => {
        dispatch({ type: "COMMENT_DELETING" });
        console.log(proid);
        console.log(markerid);
        console.log(cid);
        // async call to upload new shape
        const firebase = getFirebase();
        await firebase.database().ref().child(`Projects/${proid}/Markers/${markerid}/Comments/${cid}`).remove();
        dispatch({ type: "COMMENT_DELETED" });
    };
}

export const openDeleteCommentModal = () => {
    return {
        type: "OPEN_DELETE_COMMENT_MODAL",
    }
}
//////////////////////////////////////////////////////////////////////////////////////////////
/// README: SECTION 5 => ADD FILES UTILS
/// 
async function addMarkerImageFile(proid, newMarkerid, selectedFile) {
    var selectedFileName = selectedFile.name.replaceAll(/\s/g, '').toLowerCase();
    console.log(`Uploading: ${selectedFileName}`);
    var metadata = {
        contentType: 'images/jpg',
    };

    var storageReference = storage.ref(`Projects/${proid}/images/${selectedFileName}`);
    var uploadTask = await storageReference.put(selectedFile, metadata);
    return storageReference.getDownloadURL().then((downloadURL) => {
        return downloadURL;
    }).catch((err) => {
        console.error(err);
        return null;
    });
}

async function addMarkerElevationFile(proid, markerid, selectedFile) {
    var selectedFileName = selectedFile.name.replaceAll(/[/\-.\s]/g, '').toLowerCase();
    selectedFileName = selectedFileName.substring(0, selectedFileName.length - 'pdf'.length) + '.pdf';
    console.log(`Uploading: ${selectedFileName}`);
    var metadata = {
        contentType: 'application/pdf',
        customMetadata: {
            isProjectFile: "0",
            collectionRef: `Projects/${proid}/Markers`,
            docRef: `${markerid}`
        }
    };

    var storageReference = storage.ref(`Projects/${proid}/elevations/${selectedFileName}`);
    var uploadTask = await storageReference.put(selectedFile, metadata);
    return storageReference.getDownloadURL().then((downloadURL) => {
        return downloadURL;
    }).catch((err) => {
        console.error(err);
        return null;
    });
}

async function addCommentImageFile(proid, selectedFile) {
    var selectedFileName = selectedFile.name.replaceAll(/\s/g, '').toLowerCase();
    console.log(`Uploading: ${selectedFileName}`);
    var metadata = {
        contentType: 'images/jpg',
    };

    var storageReference = storage.ref(`Projects/${proid}/Comment/${selectedFileName}`);
    var uploadTask = await storageReference.put(selectedFile, metadata);
    return storageReference.getDownloadURL().then((downloadURL) => {
        return downloadURL;
    }).catch((err) => {
        console.error(err);
        return null;
    });
}

export const openDeleteMarkerModal = () => {
    return {
        type: "OPEN_DELETE_MARKER_MODAL",
    }
}



export const deleteMarker = (proid, markerid) => {
    return async (dispatch, getState, { getFirestore }) => {
        dispatch({ type: "DELETE_MARKER" });
        const firestore = getFirestore();
        await firestore.collection('Projects').doc(proid).collection("Markers").doc(markerid).delete();
        return dispatch({
            type: "MARKER_DELETED",
        });
    };
}